import React, {useEffect, useState} from "react";
import img from "../assets/images/DriveLink-Logo_Park_White.png";
import { AdminSideBarData } from "../Data";
import SubMenu from "./SubMenu";
import "./ComponentsStyle.css";
import {request, GET, DELETE, PUT, POST, PATCH} from "../api/ApiAdapter";
import {useHistory} from "react-router-dom";

const SideBar = () => {

    const [imageData, setImageData] = useState();

    const history = useHistory();

    const loadAccountData = async (accountId) => {
        try {
            const result = await request("accounts/" + accountId + "/images", GET);
            if (!result.error) {
                setImageData(result[0]);
            } else {
                console.log("Error");
                if (result.error.response.status === 401) {
                    console.log(result.error.response.status);
                    history.push("/page/login");
                }
            }
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        loadAccountData(`${localStorage.getItem("accountId")}`);
    }, []);

    return (
        <>
            <nav className="md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden flex flex-wrap items-center justify-between relative md:w-64 z-10 py-0 px-0">
                <div className="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto">
                    <div className="md:flex md:flex-col md:items-stretch md:opacity-100 bg-white md:relative md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center">
                        {imageData ?
                            <img
                                src={process.env.REACT_APP_API_ENDPOINT + "/accounts/image/" + imageData.id + "?updatedTime=" + encodeURI(imageData.updatedTime)}
                                className="w-44 h-20 rounded-lg ml-8"
                                alt="My profile" />
                            :
                            <div className="pt-3 pb-2 pl-4 bg-primary-light-blue" >
                                <img src={img} className="w-56" />
                            </div>
                        }
                    </div>
                    {/*<hr className="section-divider" />*/}
                    <div className="mt-0 md:flex md:flex-col md:items-stretch md:opacity-100 bg-primary-light-blue md:relative md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 ">
                        {/* Navigation */}
                        <ul class="flex flex-col py-2 px-3 ">
                            {AdminSideBarData.map((item, index) => {
                                return <SubMenu item={item} key={index} />;
                            })}
                        </ul>
                    </div>
                    <div className="flex items-center justify-center bg-primary-light-blue pt-3 pb-2 z-40">
                        <img src={img} className="h-3/5 w-3/5" />
                    </div>
                </div>
            </nav>
        </>
    );
};

export default SideBar;
